export const HumanResourcesForms = [
  { text: 'Address Change Form', path: '/assets/documents/BCMEA_Change-of-Address_Form2.pdf' },
  { text: 'Bereavement Leave', path: '/assets/documents/BCMEA_Bereavement-Leave-Application November 2024.pdf' },
  { text: 'PIPEDA Privacy Policy', path: '/assets/documents/BCMEA_PIPEDA_Policy2.pdf' },
  { text: 'Paid Medical Leave', path: '/assets/documents/BCMEA_Paid-Medical-Leave-Application_Form2.pdf' },
  { text: 'Maternity and Parental Leave', path: '/assets/documents/BCMEA_Maternity-and-Parental-Leave Application (November 2024).pdf' },
  { text: 'Personal Leave', path: '/assets/documents/BCMEA_Personal-Leave-Application_Form2.pdf' }
];

export const TrainingForms = [
  { text: 'Caulk Boots Policy', path: '/assets/documents/BCMEA_Caulk-Boot_Policy2.pdf' },
];

export const PayrollForms = [
  { text: 'Foremen Employee Change Form', path: '/assets/documents/Employee Change Form - foremen 04 July 2011.pdf' },
  { text: 'Longshore Employee Change Form', path: '/assets/documents/bcmea Change Form - longshore.pdf' },
  { text: 'Longshore Pay Statement', path: '/assets/documents/SSS_BCMEA_Nov_2016.pdf' },
];

export const FormsGroups = [
  { title: "Human Resources Forms", list: HumanResourcesForms },
  { title: "Training Forms", list: TrainingForms },
  { title: "Payroll Forms", list: PayrollForms }
]